<template>
    <div>
        <table v-loading="loading" class="table" style="border: 1px solid #F0F0F0">
            <thead>
                <tr>
                    <th scope="col" width="12%" class="header">题号</th>
                    <th scope="col" width="58%" class="header">标题</th>
                    <th scope="col" width="15%" class="header">通过率</th>
                    <th scope="col" width="15%" class="header">我的状态</th>
                </tr>
            </thead>
            <tbody>
                <tr class="hover" v-for="(item, index) in list" :key="item.id">
                    <th class="body" scope="row" @click="toProblem(item.pbid)">{{ item.number }}</th>
                    <td style="font-size:14px; font-weight:400; color:#25BBA6;" @click="toProblem(item)">{{ item.title }}</td>
                    <td class="body">
                        {{ rate[index] }}
                    </td>
                    <td class="body">
                        <!-- <span>未通过</span> -->
                        <span v-if="pass[index] === 'pass'" style="color: #25BB9B;">
                            <Icon type="md-checkmark" style="padding-right: 2px; font-size: 18px; font-weight: 600;"/>
                            通过
                        </span>
                        <span v-else >
                            未完成
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'
    export default {
        name:'CompeteProblem',
        data() {
            return {
                loading: true,
                list:null,

                pass:[],
                rate:[],
            }
        },
        mounted() {
            this.ReadOneCompeteProblem()
            if (this.$store.state.me.id !== "") this.ReadList()
            else {
                const t = setInterval(() => {
                    if (this.$store.state.me.id !== "") {
                        this.ReadList()
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }
        },
        methods: {
            ReadList() {
                const vue = this
                const store = this.$store
                const route = this.$route
                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/jdg/competition/passrate/",
                    type: 'post',
                    data: {
                        event: 'search',
                        content: route.params.id,
                        uid: store.state.me.id,
                    },
                    success(resp) {
                        console.log("resp == >", resp)
                        vue.pass = resp.pass
                        vue.rate = resp.rate
                    }
                })
            },
            toProblem(item) {
                const store = this.$store
                let number = 1

                if (item.number === 'A') number = 1
                if (item.number === 'B') number = 2
                if (item.number === 'C') number = 3
                if (item.number === 'D') number = 4
                if (item.number === 'E') number = 5
                if (item.number === 'F') number = 6

                let routeData = this.$router.resolve({
                    path:`/compete/content/problem/SubmitCode/${this.$route.params.id}/${item.pbid}/${number}`,
                });
                window.open(routeData.href, '_blank');
            },
            ReadOneCompeteProblem() {
                const vue = this
                const route = this.$route

                $.ajax({
                    url: Url.rCompeteProblemUrl,
                    type:'post',
                    data: {
                        competeId: route.params.id
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.list = JSON.parse(resp.list)
                            vue.loading = false
                        } else {
                            vue.loading = false
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.body {
    text-align: center; 
    font-size:14px; 
    font-weight:400;
}
.hover:hover {
    cursor: pointer;
}
.header {
    text-align: center; 
    background-color:#EEEEEE; 
    color: #888888; 
    font-weight:500;
}
</style>